import { computed, ref } from 'vue';
import { type searchForm as searchFormState, type RouteState } from 'shared';

type MultiCityForm = ReturnType<
  typeof searchFormState.model.useMultiCitySearchForm
>;

/**
 * Tracks which segment row the user is currently editing through a
 * bottom-sheet (city picker, calendar, …). The `index` is latched when the
 * sheet opens and read back when the sheet emits its selection — making the
 * "open → write" contract explicit instead of relying on shared free-floating
 * refs in the orchestrator.
 */
export function useSegmentEditor(searchForm: MultiCityForm) {
  const editingIndex = ref(0);

  const editingRoute = computed(
    () => searchForm.routes.value[editingIndex.value],
  );

  const setEditing = (index: number) => {
    editingIndex.value = index;
  };

  const updateEditingRoute = (patch: Partial<RouteState>) => {
    const route = editingRoute.value;
    if (route) {
      searchForm.updateRoute({ ...route, ...patch });
    }
  };

  return {
    editingIndex,
    editingRoute,
    setEditing,
    updateEditingRoute,
  };
}
